import styled from "styled-components";

export const ModI = styled.div`

.choose{
    margin-top: 12px;
    display: flex;
    justify-content: center;
}
.choose label{
    width: 300px;
    border-radius: 2px;
}
.img{
    display: flex;
    justify-content: center;
}
.img div {
    background-color: #000000aa;
    width: 170px;
    height: 170px;
    border: 2px dashed #fff;
    padding: 10px;
    display:flex;
    justify-content: center;
    align-items: center;
}
.img div img{
    max-width: 155px;
    max-height: 155px;
}
.fields div{
    position: relative;
    margin-bottom: 15px;

}
.fields div .err2{
    text-align: end;
    margin: 0px;
    position: absolute;
    top: 3px;
    right: 0px;
}
.bott-end{
    display: flex;
}
.bott-end div{
    width: 100%
}
select{
    font-weight: 500;
}
option{
    font-weight: 500;
}
input{
    font-weight: 500;
}
textarea{
    resize: none;
    font-weight: 500;
}
.btns{
    display: flex;
    justify-content: center;

}
.btns button{
    width: 300px;
    border-radius: 2px;
}
`